/**
 * repartition.js
 * --------------
 * Répartition en vigueur, journal de traçabilité et changement d'élève.
 *
 * Backend : core/repartition_journal_views.py — permission IsAdminLevel, scope
 * "fail-closed" par établissement.
 *
 * Le motif d'un changement de classe est obligatoire côté serveur : il est
 * conservé au journal et peut être versé au dossier de l'élève. L'écran le
 * demande donc, il ne le contourne pas.
 */
import axiosClient from "../axiosClient";

/** GET /directeur/repartition/en-vigueur/?niveau=
 *  -> { en_vigueur, indice_courant, mouvements_depuis, niveau }
 *  `en_vigueur` vaut null tant qu'aucune répartition n'a été validée. */
export async function getRepartitionEnVigueur(niveau) {
  const { data } = await axiosClient.get("/directeur/repartition/en-vigueur/", {
    params: niveau ? { niveau } : {},
  });
  return data || {};
}

/** GET /directeur/repartition/journal/ -> { entrees, total, niveau } */
export async function getRepartitionJournal(params = {}) {
  const { data } = await axiosClient.get("/directeur/repartition/journal/", { params });
  return data || {};
}

/** POST /directeur/repartition/mouvement/ — change un élève de classe.
 *  Le serveur refuse sans motif : c'est voulu, pas une validation cosmétique. */
export async function changerClasseEleve({ eleveId, classeCibleId, motif }) {
  const { data } = await axiosClient.post("/directeur/repartition/mouvement/", {
    eleve_id: eleveId,
    classe_cible_id: classeCibleId,
    motif,
  });
  return data;
}
